import { isNumber } from 'lodash';
import {
  QUESTION_OPEN_ENDED,
  MAX_TEXT_LENGTH,
  MIN_TEXT_LENGTH,
} from '../../../constants';

export default (question) => {
  const { style, minLength, maxLength, refId, id } = question;
  const {
    getQuestionWrapperElement,
    getMissingAnswerPrompt,
    showValidationMessage,
    getText,
  } = Pollfish.ui;
  const questionWrapper = getQuestionWrapperElement(question);

  if (style !== QUESTION_OPEN_ENDED) {
    return true;
  }

  const text = $.trim($(`#freeText-${refId || id}`).val());

  if (style === QUESTION_OPEN_ENDED && text.length < MIN_TEXT_LENGTH) {
    showValidationMessage(questionWrapper, getMissingAnswerPrompt(question));
    return false;
  }

  if (!isNumber(minLength) && !isNumber(maxLength)) {
    return !(text.length > MAX_TEXT_LENGTH);
  }

  if (
    isNumber(minLength) &&
    isNumber(maxLength) &&
    (text.length < minLength || text.length > maxLength)
  ) {
    const updatedText = getText('warnings.openEndedMinLimit').replace(
      'XXX',
      minLength,
    );
    showValidationMessage(questionWrapper, updatedText);
    return false;
  }

  if (isNumber(minLength) && text.length < minLength) {
    const updatedText = getText('warnings.openEndedMinLimit').replace(
      'XXX',
      minLength,
    );
    showValidationMessage(questionWrapper, updatedText);
    return false;
  }

  if (isNumber(maxLength) && text.length > maxLength) {
    return false;
  }

  return true;
};
